"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationDriver = function IllustrationDriver() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "66",
    height: "65",
    fill: "none",
    viewBox: "0 0 66 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    x: "0.263",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "33",
    cy: "33",
    r: "18",
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "33",
    cy: "33",
    r: "14.043",
    fill: "#F3F1F5",
    stroke: "#6F558A",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M35.957 28.565l8.87-2.956M38.174 33.74l8.13-5.175M30.043 28.565l-8.87-2.956M27.826 33.74l-8.13-5.175M35.77 37.554l-1.067 9.288M30.144 37.377l1.254 9.555M15.5 31H19M47 31h3.5M15.5 35H19M47 35h3.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "33",
    cy: "33",
    r: "5.174",
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "33",
    cy: "33",
    r: "1.478",
    fill: "#F3F1F5",
    stroke: "#6F558A",
    strokeWidth: "1.5"
  }));
};

var _default = IllustrationDriver;
exports.default = _default;